import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import Select from "react-select";


const ViewStock = () => {
    const [categoryDrp, setCategoryDrpData] = useState([]);
    const [productDrp, setProductDrpData] = useState([]);
    const [subcategoryDrp, setSubCategoryDrpData] = useState([]);
    const [sizeDrp, setSizeDrpData] = useState([]);
    const [seriesDrp, setSeriesDrpData] = useState([]);
    const [partyData, setPartyData] = useState([]);
    const [formData, setFormData] = useState({
        category_id: "0",
        sub_category_id: "0",
        size_id: "0",
        series_id: [],
        party_id: "",
        product_id: "",
    });

    const styles = {
        menu: (baseStyles, state) => ({
            ...baseStyles,
            marginTop: 2,
            zIndex: 999,
        }),
    };

    const getCategoryDrpData = () => {
        axios.post(API_URL.CATEGORY_LIST, {}).then((res) => {
            setCategoryDrpData(res.data.data);
            let cd = res.data.data.map((caw) => {
                return {
                    label: caw.name,
                    value: caw.id,
                }
            });
            setCategoryDrpData(cd)
        });
    };

    const getProductDrpData = () => {
        axios.post(API_URL.PRODUCT_LIST, {}).then((res) => {
            setProductDrpData(res.data.data);
            let cd = res.data.data.map((caw) => {
                return {
                    label: caw.name,
                    value: caw.id,
                }
            });
            setProductDrpData(cd)
        });
    };

    const getSubCategoryDrpData = (value) => {
        axios.post(API_URL.SUB_CATEGORY_LIST, { category_id: value }).then((res) => {
            setSubCategoryDrpData(res.data.data);
            let cd = res.data.data.map((caw) => {
                return {
                    label: caw.name,
                    value: caw.id,
                }
            });
            setSubCategoryDrpData(cd)
        });
    };

    const getSizeDrpData = (value) => {
        axios.post(API_URL.SIZE_LIST, { category_id: value, sub_category_id: value }).then((res) => {
            setSizeDrpData(res.data.data);
            let cd = res.data.data.map((caw) => {
                return {
                    label: caw.name,
                    value: caw.id,
                }
            });
            setSizeDrpData(cd)
        });
    };

    const getSeriesDrpData = (value) => {
        axios.post(API_URL.SERIES_LIST, { category_id: value, sub_category_id: value }).then((res) => {
            setSeriesDrpData(res.data.data);
            let cd = res.data.data.map((caw) => {
                return {
                    label: caw.name,
                    value: caw.id,
                }
            });
            setSeriesDrpData(cd)
        });
    };

    const getParty = () => {
        axios.post(API_URL.PARTY_LIST, { is_seller: [0] }).then((res) => {
            if (res.data && res.data.data && res.data.data.length > 0) {
                let pt = res.data.data.map((raw) => {
                    return {
                        address_one: raw.address_one,
                        address_two: raw.address_two,
                        city: raw.city,
                        gst_no: raw.gst_no,
                        state_name: raw.state_name,
                        name: raw.name,
                        label: raw.name,
                        value: raw.id,
                    };
                });
                setPartyData(pt);
            }
        });
    }

    useEffect(() => {
        getParty();
        getCategoryDrpData();
    }, []);

    const [seller, setSeller] = useState({
        address_one: "",
        address_two: "",
        city: "",
        gst_no: "",
        pan_no: "",
        state_id: "",
        state_name: "",
        pincode: "",
        name: ""
    });

    const setSelectedParty = (party_id) => {
        const party = partyData.find(r => r.value == party_id);
        if (party) {
            setSeller(party);
        }
    }

    return (
        <>
            <div className="page-header">
                <div className="content-page-header">
                    <h5>View Stock</h5>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className='row'>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label htmlFor="Category">Category</label>
                                <Select
                                    options={categoryDrp}
                                    value={categoryDrp.find(
                                        (r) => r.value == formData.category_id
                                    )}
                                    styles={styles}
                                    onChange={(e) => {
                                        getProductDrpData(e.value)
                                        getSubCategoryDrpData(e.value);
                                        setFormData({ ...formData, category_id: e.value })
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label htmlFor="Category">Sub Category</label>
                                <Select
                                    options={subcategoryDrp}
                                    value={subcategoryDrp.find(
                                        (r) => r.value === formData.sub_category_id
                                    )}
                                    styles={styles}
                                    onChange={(e) => {
                                        getProductDrpData(e.value)
                                        getSeriesDrpData(e.value)
                                        getSizeDrpData(e.value)
                                        setFormData({ ...formData, sub_category_id: e.value })
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label htmlFor="Category">Size</label>
                                <Select
                                    options={sizeDrp}
                                    value={sizeDrp.find(
                                        (r) => r.value === formData.size_id
                                    )}
                                    styles={styles}
                                    onChange={(e) => {
                                        getProductDrpData(e.value)
                                        setFormData({ ...formData, size_id: e.value })
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label htmlFor="Category">Series</label>
                                <Select
                                    isMulti={true}
                                    options={seriesDrp}
                                    value={formData.series_id}
                                    styles={styles}
                                    onChange={(e) => {
                                        getProductDrpData(e.value)
                                        setFormData({ ...formData, series_id: e })
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label htmlFor="name">Suplier</label>
                                <Select
                                    options={partyData}
                                    value={partyData.find((r) => r.value == formData.party_id)}
                                    styles={styles}
                                    onChange={(e) => {
                                        setSelectedParty(e.value)
                                        setFormData({ ...formData, party_id: e.value });
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label htmlFor="name">Product</label>
                                <Select
                                    options={productDrp}
                                    value={productDrp.find((r) => r.value == formData.product_id)}
                                    styles={styles}
                                    onChange={(e) => {
                                        setSelectedParty(e.value)
                                        setFormData({ ...formData, product_id: e.value });
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-group text-end">
                                <button
                                    type="submit"
                                    // onClick={saveProduct}
                                    // disabled={!isValidForm()}
                                    className="btn btn-primary"
                                >
                                    View Stock
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ViewStock